import { useEffect, useState, type ReactNode } from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import PromoBar from '../components/PromoBar'
import { AudioProvider } from '../contexts/AudioPlayer'
import { useShared } from '../lib/hooks'

function Flash() {
  const { flash } = useShared()
  const [msg, setMsg] = useState<{ text: string; kind: 'notice' | 'alert' } | null>(null)

  useEffect(() => {
    const next = flash.alert
      ? { text: flash.alert, kind: 'alert' as const }
      : flash.notice
        ? { text: flash.notice, kind: 'notice' as const }
        : null
    setMsg(next)
    if (next) {
      const t = setTimeout(() => setMsg(null), 4000)
      return () => clearTimeout(t)
    }
  }, [flash.notice, flash.alert])

  if (!msg) return null
  return (
    <div className="fixed top-20 left-1/2 -translate-x-1/2 z-50 px-4">
      <div
        role="status"
        className={`rounded-md border px-4 py-2.5 text-sm shadow-lg backdrop-blur ${
          msg.kind === 'alert'
            ? 'border-red-500/40 bg-red-500/10 text-red-300'
            : 'border-emerald-500/40 bg-emerald-500/10 text-emerald-300'
        }`}
      >
        {msg.text}
      </div>
    </div>
  )
}

function AddToCartConversion() {
  const { add_to_cart_conversion: conversion } = useShared()

  useEffect(() => {
    if (!conversion || typeof window === 'undefined' || typeof window.gtag !== 'function') return
    window.gtag('event', 'conversion', {
      send_to: conversion.send_to,
      value: conversion.value,
      currency: conversion.currency,
    })
  }, [conversion])

  return null
}

export function StoreLayout({ children }: { children: ReactNode }) {
  return (
    <AudioProvider>
      <div className="min-h-screen flex flex-col">
        <PromoBar />
        <Header />
        <Flash />
        <AddToCartConversion />
        <main className="flex-1 pb-24">{children}</main>
        <Footer />
      </div>
    </AudioProvider>
  )
}
